module.exports = __webpack_public_path__ + "static/media/cave.c19f851d.svg";